export const RECEIPT_LABEL_MAX_LENGTH = 32;
export const PROMOTION_VALUE_MIN = 1;
export const PROMOTION_VALUE_MAX = 100;
export const PROMOTION_VALUE_DECIMALS = 2;

export const PROMOTION_LANGUAGES = {
  ENGLISH: 'en',
  FRENCH: 'fr',
  SPANISH: 'es',
} as const;

export type PromotionLanguage = (typeof PROMOTION_LANGUAGES)[keyof typeof PROMOTION_LANGUAGES];

export const OPTIONAL_PROMOTION_LANGUAGES: PromotionLanguage[] = [
  PROMOTION_LANGUAGES.FRENCH,
  PROMOTION_LANGUAGES.SPANISH,
];

export const ALL_CHARGERS_ID = 'all';

export const LANGUAGE_LABEL_KEY: Record<PromotionLanguage, string> = {
  [PROMOTION_LANGUAGES.ENGLISH]: 'english_label',
  [PROMOTION_LANGUAGES.FRENCH]: 'french_label',
  [PROMOTION_LANGUAGES.SPANISH]: 'spanish_label',
};

export const LANGUAGE_ADD_KEY: Record<PromotionLanguage, string> = {
  [PROMOTION_LANGUAGES.ENGLISH]: 'add_different_english_label',
  [PROMOTION_LANGUAGES.FRENCH]: 'add_different_french_label',
  [PROMOTION_LANGUAGES.SPANISH]: 'add_different_spanish_label',
};
